(function HotelEngineValueBadge($, Adzuki)
{
	'use strict';

	const component = {
		template: `
			<div class="clip">
				<div class="clip-price">
					{{ badgeModel }}
					<br>
					<span v-if="valueFormat === 'dollar'" v-format-currency="value"></span>
					<span v-else>{{ value }} %</span>
				</div>
			</div>
		`,
		props: {
			pricing: {
				type    : Object,
				required: true,
			}
		},
		data() {
			return {
				baseUri    : Adzuki.base_uri,
				badgeModel : Adzuki.savingsBadgeModel,
				valueFormat: Adzuki.savingsValueFormat,
			};
		},
		computed: {
			value() {
				switch (this.badgeModel) {
					case 'save':
						if (this.valueFormat === 'dollar') {
							return this.pricing.savings;
						}
						return this.pricing.savings_pct;
					default:
						if (this.valueFormat === 'dollar') {
							return this.pricing.agent_commission;
						}
						return this.pricing.agent_commission_pct;
				}
			}
		}
	};

	Adzuki.VueComponents.HotelEngineValueBadge = component;
}(jQuery, window.Adzuki || {}));
